Ext.define('SA.view.menu.CreateRanking', {
    alias: 'widget.menu-create-ranking',
    extend: 'Ext.menu.Item',

    text: 'Create Ranking',

    handler() {
        var project = this.view.getProject(),
            locations = [this.location],
            attributes = [this.attribute],
            censusRelease = this.view.getCensusRelease(),
            view = project.addViewWithParams({type: 'ranking', params: {locations, attributes, censusRelease}});

        project.save();

        SA.AppController.showProjectView(view);
    }
});